import { useEffect, useState } from "react"
import { useNavigate, Outlet } from "react-router-dom"
import { auth } from "../Firebase/config"
import { onAuthStateChanged, getIdTokenResult } from "firebase/auth"
import Notify from "../Components/Componentslogic/Usenotifications"

export const ProtectedOrdertype = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          // ✅ Get latest ID token with custom claims
          const idTokenResult = await user.getIdTokenResult(true) // 🔹 Force refresh

          // ✅ Check role from Firebase Custom Claims
          const userRole = idTokenResult.claims.role || "Unknown"

          if (userRole === "Driver" || userRole === "Manager") {
            setIsAuthenticated(true)
          } else {
            Notify("Access Denied: Unauthorized Role.", "error")
            setIsAuthenticated(false)
            navigate("/Login") // 🔹 Navigate to login if unauthorized
          }
        } catch (error) {
          console.error("Error checking user role:", error)
          setIsAuthenticated(false)
          navigate("/Login") // 🔹 Navigate to login on error
        }
      } else {
        setIsAuthenticated(false) // No user logged in
        navigate("/Login") // 🔹 Navigate to login if not authenticated
      }

      setLoading(false) // Stop loading
    })

    return () => unsubscribe() // Cleanup listener
  }, [navigate])

  if (loading) return <div>Loading...</div>

  return isAuthenticated ? <Outlet /> : null
}
